'use client';

import { useLanguage } from '../contexts/LanguageContext';
import { ReactNode } from 'react';

export function LanguageLoadingScreen({ children }: { children: ReactNode }) {
  const { isLoading } = useLanguage();

  if (isLoading) {
    return (
      <div className="fixed inset-0 bg-gray-900 flex items-center justify-center z-50">
        <div className="text-center">
          <div className="inline-block animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-500 mb-4"></div>
          <p className="text-gray-300 text-sm">Laster...</p>
        </div>
      </div>
    );
  }

  return <>{children}</>;
}

